import Header from './Header';

document.addEventListener('DOMContentLoaded', () => {
  const headerElement = document.getElementById('header');
  if (headerElement) {
    const header = new Header(headerElement);
    header.mount();
  }
});
